import Image from '@anm/components/image/Image';
import getFromCdn from '@anm/helpers/getFromCdn';
import React, { FC } from 'react';

import { Wrapper } from './Wrapper';

const WaveLogo: FC = () => (
  <Wrapper>
    <Image src={getFromCdn('images/shadow-logo.svg')} alt="Wave.video" width="84" height="16" />
  </Wrapper>
);

export default WaveLogo;
